import { USE_MOCKS } from '@/lib/mocks';
import { ExamApiDatasource } from '../data/datasources/exam-api.datasource';
import { ExamMockDatasource } from '../data/datasources/exam-mock.datasource';
import { ExamRepositoryImpl } from '../data/repositories/exam.repository.impl';

/** As questões vêm do mock enquanto `USE_MOCKS` estiver ligado (o padrão). */
const datasource = USE_MOCKS
  ? new ExamMockDatasource()
  : new ExamApiDatasource();

export const examContainer = {
  repository: new ExamRepositoryImpl(datasource),
};
